import useFirebaseData from "./useFirebaseData";
import type { Project } from "../types";

const useSharedFirebaseProject = (sharing_user_id: string, project_id: string) => {
  return useFirebaseData<Project>(
    sharing_user_id && project_id
      ? `/shared_userdata/${sharing_user_id}/projects/${project_id}`
      : null
  );
};

export default useSharedFirebaseProject;
